import Highcharts from 'highcharts';

export default class ChartsUtils {
    static createBookingsChart(t, bookings_per_app: Highcharts.SeriesOptionsType[]): Highcharts.Options {
        return {
            colors: ['#434348', '#f1ae30', '#7cb5ec'],
            rangeSelector: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    tooltip: {
                        pointFormat:
                            '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y:.1f}</b><br/>',
                        xDateFormat: '%a %d/%m/%Y',
                    },
                },
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { day: '%e. %b', month: '%e. %b', year: '%b' },
            },
            yAxis: { title: { text: t('graph.nb') } },
            legend: { enabled: true },
            series: bookings_per_app,
            chart: {
                height: '240',
                type: 'areaspline',
            },
            title: {
                text: t('graph.bookings'),
            },
            time: {
                timezone: undefined,
            },
            navigator: {
                enabled: false,
            },
            accessibility: {
                enabled: false,
            },
        };
    }

    static createSpeedChart(
        t,
        speed_per_app: Highcharts.SeriesOptionsType[],
        routes: { [key: number]: { lat: number; lng: number } },
        showOnMap,
        map,
        maps,
    ): Highcharts.Options {
        // Attach route info to each point based on timestamp
        const enhancedSeries = speed_per_app.map((series) => {
            if (series && typeof series === 'object' && 'data' in series && Array.isArray(series.data)) {
                return {
                    ...series,
                    data: series.data.map((point) => {
                        // Highcharts points can be [x, y] or { x, y, ... }
                        let timestamp: number;
                        if (Array.isArray(point)) {
                            timestamp = point[0];
                            return {
                                x: point[0],
                                y: point[1],
                                route: routes[timestamp],
                            };
                        } else if (typeof point === 'object' && point !== null && 'x' in point) {
                            timestamp = (point as any).x;
                            return {
                                ...point,
                                route: routes[timestamp],
                            };
                        }
                        return point;
                    }),
                };
            }
            return series;
        });

        return {
            colors: ['#434348', '#f1ae30', '#7cb5ec'],
            rangeSelector: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    point: {
                        events: {
                            mouseOver: (el) => showOnMap(el, map, maps),
                        },
                    },
                },
            },
            tooltip: {
                useHTML: true,
                formatter: function () {
                    const route = (this as any).route;
                    // Use chart's time instance for consistent timezone formatting
                    const dateStr = this.series.chart.time.dateFormat('%a %d/%m/%Y, %H:%M:%S', this.x);
                    let s = dateStr + '<br/>';
                    s +=
                        '<span style="color:' +
                        (this as any).color +
                        '">\u25CF</span> ' +
                        this.series.name +
                        ': <b>' +
                        (this as any).y.toFixed(1) +
                        '</b><br/>';
                    if (route && typeof route.lat !== 'undefined' && typeof route.lng !== 'undefined') {
                        s += 'Lat: <b>' + route.lat + '</b>, Lng: <b>' + route.lng + '</b><br/>';
                    }
                    return s;
                },
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: { day: '%e. %b', month: '%e. %b', year: '%b' },
            },
            yAxis: { title: { text: t('speedKm') } },
            legend: { enabled: true },
            series: enhancedSeries as Highcharts.SeriesOptionsType[],
            chart: {
                height: '240',
                type: 'areaspline',
            },
            title: {
                text: t('speed'),
            },
            time: {
                timezone: undefined,
            },
            navigator: {
                enabled: false,
            },
            accessibility: {
                enabled: false,
            },
        };
    }
}
